<template>
  <div>
    <div v-if="isLoading" class="loader-overlay">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>

        <!-- Start the code for this screen here -->
        <div
          id="employee"
          class="container-fluid menu-margin-top mr-sm-3 mr-lg-0"
          style="z-index:1;padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Role List</b>
              </span>
            </nav>

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-between">
              <!-- <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label id="lnamelaabel" class="col-form-label col-form-label-sm">Role Name</label>
              </div> -->
              <!--col end-->
              <div
                class="col-3 col-md-6 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-3"
              ></div>
              <div
                class="col-6 col-md-6 justify-content-center align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-3"
              >
                <input
                  id="lname"
                  class="form-control input-sm"
                  placeholder="Search role"
                  v-model="searchRole"
                />
              </div>
              <div
                class="col-3 col-md-6 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-3 text-right"
              >
              <router-link class="newRoleBtn text-end" to="/addNewRole">+ Add New Role</router-link>
              </div>
              
              
            </div>
            <!--row end-->
            <br />
            <center class="mb-2">
              <button type="submit" @click="search" class="btn btn-secondary">Search</button>&nbsp;&nbsp;&nbsp;
              <button
                type="submit"
                @click="clearSearch"
                class="btn btn-secondary"
              >Reset</button>
            </center>

            <div class="row mt-2 justify-content-center">
                <div class="col">
                  <div class="table-responsive-sm table-responsive-sm mb-5 tbl-update-dealer">
                    <v-table
                      id="myemployeelistTable"
                      :data="roleList"
                      class="table table-sm table-bordered table-striped"
                    >
                      <thead class="table-month-header-blue wrap-text" slot="head">
                        <v-th sortKey="userRoleX">Role Name</v-th>
                        <v-th sortKey="userRoleC">Actions</v-th>
                      </thead>
                      <tbody slot="body" slot-scope="{ displayData }" v-if="roleList.length > 0">
                        <tr v-for="(role,index) of displayData" :key="index" v-if="role.userRoleX !== 'Super Admin'">
                          <td class="table-month-td">{{role.userRoleX}}</td>
                          <td class="table-month-td text-center">
                            <button
                              type="submit"
                              class="btn btn-secondary btn-edit mr-3"
                              :class="role.userRoleX == 'Super Admin' ? 'disabled' : ''"
                              :disabled="role.userRoleX == 'Super Admin'"
                              @click="goToPermissions(role.userRoleC)"
                            >Permissions</button>
                            <button
                              type="submit"
                              :disabled="role.userRoleX == 'Super Admin'"
                              class="btn btn-secondary btn-edit mr-3"
                              :class="role.userRoleX == 'Super Admin' ? 'disabled' : ''"
                              @click="goToEditRole(role.userRoleC)"
                            >Edit</button>
                            <button
                              type="submit"
                              :disabled="role.userRoleX == 'Super Admin'"
                              class="btn btn-secondary btn-edit mr-3"
                              :class="role.userRoleX == 'Super Admin' ? 'disabled' : ''"
                              @click="confirmDelete(role.userRoleC)"
                            >Delete</button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="2" class="text-center">{{noResult}}</td>
                        </tr>
                      </tbody>
                    </v-table>
                  </div>
                </div>
              </div>
          </div>
          <div class="mt-5 mb-5 pb-3">
          <b-pagination
            align="center"
            v-if="rows > perPage && roleList.length > 0"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-number
            last-number
            @input="pagination"
            class="customPagination"
          ></b-pagination>
        </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
      <div @click.self="isDeleteRole = false" v-if="isDeleteRole" class="modal" id="mergeSelect">
          <div class="modal-content">
            <div class="modal-heading">
              <h4>Delete Role</h4>
            </div>
            <div class="modal-body">
              <img src="../assets/deleteicon.png" alt="" class="logo mt-2" />
              <p class="modalText mt-3 mb-4">
                Are you sure, Do you want to delete role ?
              </p>
              <!-- <img src="../assets/question.jpg" alt=""> -->
              <div class="d-flex justify-content-center mt-2 mb-1">
              <button
                type="button"
                class="btn mergeButton mx-2"
                @click="deleteRole()"
              >
                Delete
              </button>
              <button type="button" @click="isDeleteRole = false"  class="btn yesButton mx-2">Cancel</button>
              </div>
            </div>
          </div>
        </div>

        <div @click.self="isNotDeleted = false" v-if="isNotDeleted" class="modal" id="mergeSelect">
          <div class="modal-content desc">
            <!-- <div class="modal-heading">
              <h4>Delete Role</h4>
            </div> -->
            <div class="modal-body">
              <img src="../assets/Unable-to-Delete-Role.svg" alt="" class="logo" />
              <div class="mt-2">
                <h4>Unable to Delete Role</h4>
              </div>
              <p class="modalText desc mt-3 mb-4">
                These role cannot be deleted because {{employeeCount}} employees are currently assigned to it. Please reassign these eployees to another role before proceeding.
              </p>
              <!-- <img src="../assets/question.jpg" alt=""> -->
              <div class="d-flex justify-content-center mt-2 mb-1">
              <button
                type="button"
                class="btn mergeButton del mx-2"
                @click="goToViewEmp(roleId)"
              >
                View Employees
              </button>
              </div>
              <div class="d-flex justify-content-center mt-2 mb-1">
              <button type="button" @click="isNotDeleted = false"  class="btn yesButton del mx-2">Cancel</button>
              </div>
            </div>
          </div>
        </div> 
    </div>
  </div>
</template>
<script>
import TopHeader from "@/components/TopHeader.vue";
import MainMenu from "@/components/Menu.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import httpcommon from "../js/http-common.js";
import moment from "moment";
import { search } from "core-js/fn/symbol";
import { watch } from "vue";

export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter,
  },
  name: "roleManagement",

  data() {
    return {
      roleList: [],
      noResult: "",
      isLoading: false,
      rows: 0,
      currentPage: 1,
      perPage: 10,
      isSearch: false,
      isDeleteRole: false,
      roleId: '',
      isNotDeleted: false,
      employeeCount: '',
      searchRole: ''
    };
  },
  methods: {
    getRoleList () {
      this.isLoading = true
      httpcommon.get(`/acl/roles/list`).then(response=>{
            this.isLoading = false
            console.log(response)
            if(response.data.content.length>0) {
                this.roleList = response.data.content
            } else {
                this.noResult = 'No Result Found'
            }
        }).catch(error=>{
            this.isLoading = false
            console.log(error)
        })
      // this.roleList = ["Admin", "Back Office", "Credit Analyst", "Sales Rep"];
    },
    pagination() {
      // this.getRoleList()
    },

    confirmDelete (id) {
      this.isDeleteRole = true
      this.roleId = id
    },

    deleteRole () {
      httpcommon
      .delete('/acl/roles?roleId='+this.roleId)
      .then(response=>{
        this.isDeleteRole = false
        this.getRoleList()
      }).catch(error=>{
        if (error.response && error.response.data) {
          // Access the message from the response body
          const errorMessage = error.response.data.message;
          if(error.response.data.status == '400' && error.response.data.message.includes('Unable to delete role because found')) {
            let msg = error.response.data.message.split(' ')
            let index = msg.indexOf('found');
            this.employeeCount = msg[index+1]
            this.isNotDeleted = true;
            this.isDeleteRole = false
          }
          console.log('Error:', errorMessage);  // This is where you get the error message
        } else {
          console.log('Error:', error);
        }
      })
    },

    goToAddRole() {
      this.$router.push('/addNewRole')
    },

    goToPermissions (roleId) {
      this.$router.push({ name: 'rolePermissions', params: { roleId } })
    },

    goToEditRole(roleId) {
      this.$router.push({ name: 'editRole', params: { roleId } })
    },

    goToViewEmp(roleId) {
      this.$router.push({ name: 'viewUpdateEmployee', query: { roleId: roleId }  })
    },
    search() {
      this.isLoading = true
      httpcommon.get(`/acl/roles/list?filter=${this.searchRole}`).then(response=>{
            this.isLoading = false
            console.log(response)
            if(response.data.content.length>0) {
                this.roleList = response.data.content
            } else {
              this.roleList = []
                this.noResult = 'No Result Found'
            }
        }).catch(error=>{
            this.isLoading = false
            console.log(error)
        })
    },
    clearSearch() {
      this.searchRole = '';
      // this.getRoleList();
    },

    myFunction() {
      var elmnt = document.getElementById("height2");
      var elmnt1 = document.getElementById("height3");
      var txt = elmnt.offsetHeight;
      var width = elmnt.offsetWidth;
      var txt1 = elmnt1.offsetHeight;
      var ht = txt + txt1;
      $("#employee").css("margin-top", txt + txt1 + 3);
    },
    menuheight() {
      var elmnt = document.getElementById("height2");
      var txt = elmnt.offsetHeight;
      $("#height3").css("margin-top", txt);
    },
  },
  watch: {
    searchRole: function (val) {
      if(val == '') {
        this.getRoleList()
      }
    }
  },
  created() {
    window.addEventListener("resize", this.myFunction);
    window.addEventListener("resize", this.menuheight);
  },
  mounted() {
    this.myFunction();
    this.menuheight();
    this.getRoleList();
  },
};
</script>
<style scoped>
.customerTable {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
  table-layout: auto;
  width: 100%;
}
.customerTable thead tr {
  color: #9b9b9b;
  font: 600 14px "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
}
.customerTable thead tr th {
  border-top: none;
  white-space: nowrap;
}
.customerTable tbody tr td {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
}
tbody tr {
  border-bottom: 1px solid #dbdbdb;
}
.mergeStatus {
  color: #00aa00 !important;
}
.unMergeStatus {
  color: #f22a0e !important;
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.customPagination ::v-deep .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 10px;
  font-size: 20px;
  color: #9b9b9b;
}
.customPagination ::v-deep .active .page-link {
  background-color: #005df1;
  border-radius: 8px;
  color: #ffffff;
}
.pagination.customPagination ::v-deep .page-item:first-child .page-link,
.pagination.customPagination ::v-deep .page-item:last-child .page-link {
  font-size: 40px !important; /* Adjust the font size as needed */
  padding: 0 20px 10px 20px;
}
.navLinks {
  list-style: none;
  display: flex;
  padding-left: 0;
  justify-content: center;
}
.navLinks li {
  padding: 10px 35px 10px 0px;
}
.linkItem {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #8c8c8c;
  padding: 10px 30px 10px 30px;
  border-radius: 8px;
}
.linkItem:hover {
  color: #ffffff;
  background-color: #1e90ff;
}
.navLinks .active {
  color: #ffffff !important;
  background-color: #1e90ff;
}
.activitySearch input {
  font: 400;
  font-size: 16px;
  color: #1c1b1f;
  border: 1px solid #e4ecf4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
.activityBtn button {
  border-radius: 8px;
  color: #ffffff;
  font-weight: 600;
  font-size: 18px;
  background-color: #1e90ff;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  width: 100%;
}
.clearText {
  text-align: end;
  /* padding-right: 25px; */
  margin: 0;
}
.clearText a {
  cursor: pointer;
  color: #91a7bd;
  font-weight: 400;
  font-size: 13px;
  text-decoration: underline;
}
.clearText a:hover {
  color: #1e90ff;
}

.action {
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  padding: 6px 12px 6px 12px;
  height: 40px;
  border: none;
  line-height: 28px;
}

.editAction {
  color: #ffffff;
  background-color: #1e90ff;
  margin-right: 15px;
}
.deleteAction {
  color: #ffffff;
  background-color: #6d859d;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}

.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modalText.desc {
  opacity: .5;
  padding:  0px 20px !important;
}
.modal-body img {
  height:70px
}
.mergeButton,.yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  /* margin: auto; */
}
.mergeButton.del,.yesButton.del {
  width: 100%;
}
.btn-edit {
    font-size: 12px;
    padding: 0.2rem 0.75rem;
  }
  
  .wrap-text {
    white-space: nowrap;
  }
  .search-wrapper {
  position: relative;
}

.clear-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.clear-btn::after {
  content: '\2715'; /* Unicode for heavy multiplication x */
  font-size: 1em;
  color: #000;
  font-weight: bold;
}
.disabled {
  cursor: not-allowed;
  background-color: #6d859d;
}
.newRoleBtn {
  color: dodgerblue;
  font-weight: 600;
  font-family: Arial, Helvetica, sans-serif;
  padding-right: 15px;
}
.table-sm th, .table-sm td {
  width: 50% !important;
}
</style>
